/**
 * src/components/ui/Textarea.jsx — labelled multi-line text input.
 *
 * Same Field wrapper as Input.jsx — see that file's header for why the
 * validation/error plumbing lives there, not here.
 */
import { Field, syncAriaInvalid } from './Field.jsx';

/**
 * @param {{
 *   label: string,
 *   hint?: React.ReactNode,
 *   error?: string|null,
 *   required?: boolean,
 *   id?: string,
 * } & React.TextareaHTMLAttributes<HTMLTextAreaElement>} props
 * @returns {JSX.Element}
 */
export function Textarea({ label, hint, error, required, id, onBlur, onInput, ...textareaProps }) {
  return (
    <Field label={label} hint={hint} error={error} required={required} htmlFor={id}>
      {({ inputId, hintId, errorId }) => (
        <textarea
          id={inputId}
          required={required}
          aria-describedby={hintId}
          aria-errormessage={error ? errorId : undefined}
          aria-invalid={error ? 'true' : undefined}
          onBlur={(e) => {
            syncAriaInvalid(e);
            onBlur?.(e);
          }}
          onInput={(e) => {
            syncAriaInvalid(e);
            onInput?.(e);
          }}
          {...textareaProps}
        />
      )}
    </Field>
  );
}
